export default __webpack_public_path__ + "static/media/gold-4.64bbc0df.png";